export default "__VITE_ASSET__b3019d40__"